// extracted by mini-css-extract-plugin
module.exports = {"varSpDown1":"0.75rem","varSpUp3":"1.75rem","removeContainer":"removeContainer--34c96"};